// eslint-disable-next-line import/no-internal-modules
import ColorPicker from '@insided/deprecated-preact-components/theme-configuration/ColorPicker'
import { Component } from 'preact'
import FieldContainer, { FieldContainerProps } from './FieldContainer'
import { AbstractFieldProps } from './types'

export type ColorValue = string

export interface ColorFieldProps
  extends AbstractFieldProps<ColorValue>,
    Omit<FieldContainerProps, 'children'> {
  inputId: FieldContainerProps['inputId']
  title: FieldContainerProps['title']
  defaultValue: ColorValue
}

interface FieldState {
  value: ColorValue
  /** TODO
   * isColorSelectorEnabled should be hidden inside implementation of ColorPicker
   */
  isColorSelectorEnabled: boolean
}

export class ColorPickerField extends Component<ColorFieldProps, FieldState> {
  state = {
    isColorSelectorEnabled: false,
    value: this.props.value ?? this.props.defaultValue
  }

  render() {
    const { inputId, title } = this.props
    return (
      <FieldContainer inputId={inputId} title={title}>
        <ColorPicker
          id={inputId}
          position='top'
          color={this.state.value}
          disabled={false}
          isColorSelectorEnabled={this.state.isColorSelectorEnabled}
          updateColor={(value) => {
            this.setState({ value }, () => this.props.onValueChange(value))
          }}
          disableColorSelector={() => this.setState({ isColorSelectorEnabled: false })}
          setColorSelector={() => this.setState({ isColorSelectorEnabled: true })}
        />
      </FieldContainer>
    )
  }
}

export default ColorPickerField
